export default "__VITE_ASSET__BjU_$hgY__"